import React from 'react';
import noop from 'mn-utils/noop';
import delay from 'mn-utils/delay';
import map from 'mn-utils/map';
import find from 'mn-utils/find';
import filter from 'mn-utils/filter';
import forEach from 'mn-utils/forEach';
import {
  popupWindowParams$,
} from '../../../../emitters/popup';
import withState from '../../../../utils/withState';
import OneWindow from './OneWindow';


module.exports = withState((setState, self) => {
  let _index = 0;
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      const {
        state,
      } = self;
      const windows = state.params[1] || [];
      const closedWindows = [];
      const newWindows = [];
      const animatedWindows = state.animatedWindows || [];

      forEach(windows.slice(0, Math.min(windows.length, _index)), (item) => {
        find(animatedWindows, ['id', item.id]) || newWindows.push(item);
      });

      forEach(animatedWindows, (item) => {
        item.index > _index && closedWindows.push(item);
      });

      setState({
        animatedWindows: [
          ...map(animatedWindows, (item) => {
            return item.index > _index ? {
              ...item,
              animated: false,
            } : item;
          }),
          ...newWindows,
        ],
      });

      newWindows.length && delay(() => {
        setState({
          animatedWindows: map(self.state.animatedWindows, (item) => {
            return find(newWindows, ['id', item.id]) ? {
              ...item,
              animated: true,
            } : item;
          }),
        });
      }, 50);

      closedWindows.length && delay(() => {
        setState({
          animatedWindows: filter(self.state.animatedWindows, (item) => {
            return !find(closedWindows, ['id', item.id]);
          }),
        });
      }, 230);
    });
  }

  return (state) => {
    const index = state.params[0] || 0;

    _index === index || update(_index = index);


    return map(state.animatedWindows, (item) => {
      return (
        <OneWindow
          key={item.id}
          data={item}
        />
      );
    }, []);
  };
}, {
  params: popupWindowParams$,
});
